var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 125,
    viewBox: "0 0 125 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121.952 30.8613L94.2197 3.13195C93.2975 2.20984 92.2026 1.47836 90.9976 0.979308C89.7925 0.480252 88.5009 0.223389 87.1966 0.223389C85.8922 0.223389 84.6006 0.480252 83.3956 0.979308C82.1905 1.47836 81.0956 2.20984 80.1734 3.13195L3.63524 79.6498C2.70903 80.5684 1.97471 81.6618 1.47496 82.8665C0.975211 84.0713 0.720003 85.3633 0.724171 86.6675V114.397C0.724171 117.03 1.77049 119.555 3.63294 121.417C5.49539 123.279 8.02142 124.325 10.6553 124.325H38.3943C39.6989 124.329 40.9914 124.074 42.1965 123.574C43.4017 123.074 44.4955 122.34 45.4144 121.414L121.952 44.9028C122.875 43.9809 123.607 42.8864 124.106 41.6818C124.605 40.4771 124.862 39.186 124.862 37.8821C124.862 36.5781 124.605 35.287 124.106 34.0824C123.607 32.8777 122.875 31.7832 121.952 30.8613ZM12.7098 84.6137L65.2766 32.065L75.6361 42.4209L23.0693 94.9633L12.7098 84.6137ZM10.6553 96.5952L28.4631 114.397H10.6553V96.5952ZM40.4488 112.343L30.0893 101.987L82.6562 49.4385L93.0156 59.7944L40.4488 112.343ZM100.036 52.7767L72.2967 25.0474L87.1935 10.1558L114.932 37.879L100.036 52.7767Z",
    fill: "#FF813B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectIcon);
export default __webpack_public_path__ + "static/media/project_icon.f99c4b4c335cd907767ef3f60a2686bb.svg";
export { ForwardRef as ReactComponent };